import { EnumBase } from 'hay-core-react';
class PlanoAtivacaoEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.plano.ativacao.automatica',
                'main.plano.ativacao.voucher',
            ],
            'main.plano.ativacao.automatica'
        );
    }
}

const instance = new PlanoAtivacaoEnum();
export default instance;
